import { LevelData } from '../types';

const STORAGE_KEY = 'numberSequenceGame';

export const storage = {
  saveLevelData: (levelData: LevelData) => {
    const existingData = storage.getAllSessions();
    existingData.push(levelData);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(existingData));
  },

  getAllSessions: (): LevelData[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  },

  getSessionData: (sessionId: string): LevelData[] => {
    const allData = storage.getAllSessions();
    return allData.filter(data => data.sessionId === sessionId);
  },

  clearAllData: () => {
    localStorage.removeItem(STORAGE_KEY);
  },

  exportToCSV: (sessionId?: string): string => {
    const data = sessionId ? storage.getSessionData(sessionId) : storage.getAllSessions();
    const headers = 'patient_id,session_id,level,timestamp_start,timestamp_end,grid_size,obstacles_count,moves,errors,completion_time_sec,accuracy_pct,score,difficulty_index,dda_action';
    const rows = data.map(row => 
      `${row.patientId},${row.sessionId},${row.level},${row.timestampStart},${row.timestampEnd},${row.gridSize},${row.obstaclesCount},${row.moves},${row.errors},${row.completionTimeSec},${row.accuracyPct},${row.score},${row.difficultyIndex},${row.ddaAction}`
    );
    return [headers, ...rows].join('\n');
  },

  exportToJSON: (sessionId?: string): string => {
    const data = sessionId ? storage.getSessionData(sessionId) : storage.getAllSessions();
    return JSON.stringify(data, null, 2);
  },

  downloadFile: (content: string, filename: string) => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};